import { render, staticRenderFns } from "./login-view.vue?vue&type=template&id=66215df9&scoped=true&"
import script from "./login-view.vue?vue&type=script&lang=ts&"
export * from "./login-view.vue?vue&type=script&lang=ts&"
import style0 from "./login-view.vue?vue&type=style&index=0&id=66215df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66215df9",
  null
  
)

export default component.exports